module.exports = __webpack_public_path__ + "img/we-blog.84c32d4e.svg";